const addThousandsSeperators = (value) => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'); // NOSONAR
export const transformDotToComma = (value, { fallback = null } = { fallback: null }) => {
    if (value === undefined)
        return fallback;
    return value.toString().replace(/\./g, ',');
};
export const stripEmptyDecimals = (value) => value.replace(/\.[0]+$/, '');
export const formatNumber = (value, { fallback = null, decimals, prefix, suffix, hideEmptyDecimals, ignoreZero } = {
    decimals: 0,
    prefix: '',
    suffix: '',
    hideEmptyDecimals: true,
    ignoreZero: false,
    fallback: null,
}) => {
    if (value === undefined || Number.isNaN(value) || (ignoreZero && value === 0))
        return fallback;
    let num = value.toFixed(decimals);
    num = hideEmptyDecimals ? stripEmptyDecimals(num) : num;
    num = transformDotToComma(num);
    num = addThousandsSeperators(num);
    return `${prefix || ''}${num}${suffix || ''}`;
};
export const formatNumberAsIs = (value, { fallback = null, decimals } = { decimals: 0, fallback: null }) => formatNumber(value, {
    decimals,
    fallback,
});
export const formatNumberNoDecimals = (value, { fallback = null } = { fallback: null }) => formatNumber(value, {
    decimals: 0,
    fallback,
});
export const formatPriceWithDecimals = (value, { fallback = null, decimals } = { decimals: 0, fallback: null }) => formatNumber(value, {
    decimals,
    prefix: '€ ',
    fallback,
});
